import { API } from '../../../common/api'
import { gcpMarketplaceServiceUrl } from '../../../common/utils/constants'
import {
  parseSubscriptionExpiringDaysParam,
  subscriptionFilterStatusToGcpApiParam,
} from '../../../common/utils/subscriptionsFilterMapping'
import type { PartnerSubscriptionsListParams } from '../../modules/subscription/reducer'

export const fetchGcpProductsList = (partnerId: string) => {
  return API.get(`${gcpMarketplaceServiceUrl}/partners/${partnerId}/products`, {
    params: {
      include: 'plans',
    },
  })
}

export const getGcpSinglePrivateOffer = (
  partnerId: string,
  privateOfferId: string,
  crmOpportunityId?: string,
  productId?: string
) => {
  return API.get(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${privateOfferId}`,
    {
      params: {
        product_id: productId,
        crm_opportunity_id: crmOpportunityId,
      },
    }
  )
}

export const getGCPPrivateOffersData = ({
  partnerId,
  pageSize,
  pageNumber,
  productId,
  crmOpportunityId,
}: {
  partnerId: string
  productId?: string
  pageSize?: number
  pageNumber?: number
  crmOpportunityId?: string
}) => {
  return API.get(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/private_offers`,
    {
      params: {
        page_size: pageSize,
        page_number: pageNumber,
        crm_opportunity_id: crmOpportunityId,
        ...(productId ? { product_id: productId } : {}),
      },
    }
  )
}

export const patchGCPPrivateOffersData = (
  partnerId: string,
  privateOfferId: string,
  data: Record<string, unknown>
) => {
  return API.patch(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/private_offers/${privateOfferId}`,
    data
  )
}

export const getGCPContractsData = ({
  partnerId,
  productId,
  pageSize = 30,
  pageNumber = 1,
  status,
  expiringDays,
  sortBy = 'start_date',
  sortOrder = 'asc',
}: PartnerSubscriptionsListParams) => {
  const expiring = parseSubscriptionExpiringDaysParam(expiringDays)
  const gcpStatus = subscriptionFilterStatusToGcpApiParam(status)
  const effectiveProductId =
    productId && productId !== 'all' ? productId : undefined
  return API.get(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/subscriptions`,
    {
      params: {
        page_size: pageSize,
        page_number: pageNumber,
        include: 'plans, offer',
        sort_by: sortBy,
        sort_order: sortOrder.toUpperCase() as 'ASC' | 'DESC',
        ...(gcpStatus ? { status: gcpStatus } : {}),
        ...(expiring !== undefined ? { expiring_days: expiring } : {}),
        ...(effectiveProductId ? { product_id: effectiveProductId } : {}),
      },
    }
  )
}

export const postGCPContractsData = (
  data: Record<string, unknown>,
  partnerId: string
) => {
  return API.post(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/metering`,
    data
  )
}
export const putGCPPrivateOffersData = ({
  partnerId,
  data,
}: {
  partnerId: string
  data: Record<string, unknown>
  saveAsDraft?: boolean
}) => {
  return API.put(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/private_offers`,
    data
  )
}

export const getGcpSubscriptionDetail = (
  partnerId: string,
  subscriptionId: string
) => {
  return API.get(
    `${gcpMarketplaceServiceUrl}/partners/${partnerId}/subscriptions/${subscriptionId}`
  )
}
